/* One assignment across both product pages and the cart. No request for assignment. */
(() => {
  const state = window.AveyBottleExperimentState;
  if (!state) return;
  const eligibleProducts = new Set(['6751418384519', '8487312032074']);
  const seen = new WeakSet();
  const offerScript = document.currentScript?.dataset.bottleOfferScript;
  let offerModule;
  function loadOffers(root = document) {
    if (state.variant !== 'B' || !offerScript) return;
    const offer = root.querySelector('avey-cart-bottle-offer');
    const dialog = offer?.closest('dialog');
    if (!offer || (dialog && !dialog.open)) return;
    offerModule ||= import(offerScript).catch(() => { offerModule = null; offer.hidden = true; });
  }
  function save() {
    try { localStorage.setItem(state.key, JSON.stringify(state.assignment)); } catch (_) { state.track = false; }
  }
  function properties(previous = {}) {
    const a = state.assignment;
    if (!state.track || !a?.first_product_page || a.expires_at <= Date.now()) return {};
    const key = '_avey_ab_' + state.id;
    return { ...previous, ...(previous[key] && previous[key] !== state.variant ? { [key + '_mixed']: 'true' } : {}), [key]: state.variant, [key + '_first_product_page']: a.first_product_page,
      [key + '_country']: a.first_country, [key + '_language']: a.first_language };
  }
  function expose(element, productId, placement) {
    if (!state.track || seen.has(element) || !eligibleProducts.has(String(productId))) return;
    seen.add(element);
    const observer = new IntersectionObserver((entries) => {
      if (!entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= .5)) return;
      observer.disconnect();
      const page = placement === 'cart' ? 'cart' : location.pathname.split('/').filter(Boolean).pop();
      const a = state.assignment;
      if (!a.first_product_page) {
        a.first_product_page = page;
        a.first_country = document.body.dataset.countryCode;
        a.first_language = document.documentElement.lang;
      }
      a.exposed_product_ids ||= [];
      if (!a.exposed_product_ids.includes(String(productId))) a.exposed_product_ids.push(String(productId));
      save();
      let attempts = 0;
      const publish = () => {
        if (!state.track) return;
        if (window.Shopify?.analytics?.publish) {
          window.Shopify.analytics.publish('avey:ab_exposure', {
            experiment_id: state.id, experiment_variant: state.variant,
            experiment_first_product_page: a.first_product_page, experiment_product_page: page,
            experiment_country: document.body.dataset.countryCode, experiment_language: document.documentElement.lang,
            experiment_copy_mode: 'single_bottle_cart_v1', product_id: String(productId), placement,
          });
        } else if (++attempts < 20) window.setTimeout(publish, 250);
      };
      publish();
    }, { threshold: .5 });
    observer.observe(element);
  }
  function prepareProduct(root) {
    if (!root.hasAttribute('data-single-bottle-eligible')) return;
    if (state.variant === 'B' && !root.classList.contains('avey-bundles--single-preview')) {
      root.dataset.quickBuyDefaultQuantity ||= root.querySelector('[data-bundle-radio]:checked')?.closest('[data-bundle-card]')?.dataset.quantity || '1';
      root.querySelectorAll('[data-bundle-card]').forEach(card => {
        if (Number(card.dataset.quantity) > 1) {
          const template = document.createElement('template');
          template.setAttribute('data-quick-buy-extra-offer', '');
          card.before(template); template.content.append(card);
        }
      });
      const card = root.querySelector('[data-bundle-card]');
      if (!card) return;
      const radio = card.querySelector('[data-bundle-radio]');
      // Keep the native offer metadata for submission and quick buy, without a
      // radio or its interactive label on the single-bottle product page.
      if (radio) { radio.type = 'hidden'; radio.checked = true; }
      const choice = card.querySelector('label.avey-bundle__choice');
      if (choice) {
        const summary = document.createElement('div');
        summary.className = choice.className;
        summary.append(...choice.childNodes);
        choice.replaceWith(summary);
      }
      root.querySelector('legend')?.classList.add('visually-hidden');
      const heading = card.querySelector('.avey-bundle__shade-heading');
      const legend = root.querySelector('legend');
      if (legend && heading?.querySelector('strong')) legend.textContent = heading.querySelector('strong').textContent;
      const list = card.querySelector('.avey-bundle__shade-list');
      if (heading && list) list.after(heading);
      const guide = heading?.querySelector('button');
      if (guide && root.dataset.singleBottleGuide) guide.textContent = root.dataset.singleBottleGuide;
      root.classList.add('avey-bundles--single-preview');
    }
    expose(root.querySelector('[data-bundle-card]') || root, root.dataset.productId, 'product');
  }
  function prepareCart(root) {
    root.querySelectorAll('template[data-single-bottle-cart]').forEach(template => {
      if (state.variant === 'B') {
        const scroll = template.closest('[data-cart-drawer-scroll]');
        scroll?.querySelector('.avey-cart-recommendations')?.remove();
        template.replaceWith(template.content.cloneNode(true));
      } else template.remove();
    });
  }
  function exposeCart(root = document) {
    loadOffers(root);
    root.querySelectorAll('[data-cart-drawer-scroll] [data-cart-line]').forEach(line => {
      const dialog = line.closest('dialog');
      if (dialog && !dialog.open) return;
      if (eligibleProducts.has(line.dataset.productId)) expose(line, line.dataset.productId, 'cart');
    });
  }
  window.AveyBottleExperiment = { properties, prepareProduct, prepareCart, exposeCart };
  prepareCart(document);
  exposeCart();
  document.addEventListener('avey:overlay:open', () => exposeCart());
  document.addEventListener('avey:cart:updated', () => exposeCart());
})();
